import { IAddress } from '@cemex-core/cmx-api/models/address/address.interface';
import { IAddressResponse } from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';
import { IJobsiteSalesArea } from '@cemex-core/cmx-api/models/jobsite-sales-areas/jobsite-sales-area';
import { Plant } from '@cemex-core/cmx-api/models/order-management/plant';
import { IShipmentLocation } from '@cemex-core/cmx-api/models/shipment-location/shipment-location';
import {
  JobsiteActions,
  JOBSITE_SET,
  JOBSITE_SET_AVAILABILITY,
  LOAD,
  LOAD_ADDRESS,
  LOAD_ADDRESS_SUCCESS,
  LOAD_COMPLETE,
  PATCH_ADDRESS_COORDINATES,
  LOAD_INITIAL_STATE,
  LOAD_SALES_AREA,
  LOAD_SALES_AREA_SUCCESS,
  LOAD_STD_LOT_SUCCESS,
  RESET,
  SET_JOBSITE_PLANT,
  LOAD_NO_SHIPPING_CONDITION,
  LOAD_NO_DOCUMENTS,
  LOAD_FULL_SALES_AREA_SUCCESS,
  LOAD_FULL_SALES_AREA_FAIL,
} from '../../actions/jobsite-actions/jobsite.actions';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { MultipleStdLotSizeRes } from '@cemex-core/cmx-api/models/std-lot-size/multiple-std-lot-size-res';
import { FullSalesArea } from '@cemex-core/cmx-api';

/**
 * A state-object which describes the jobsite selector control in the OT workflow, and also
 * the item selected from those available.
 */
export interface IJobsiteState {
  loaded: boolean;
  loading: boolean;
  jobsites: IShipmentLocation[];
  required: boolean;
  disabled: boolean;
  visible: boolean;
  selected: IShipmentLocation;
  address: IAddress;
  jobsiteSalesArea: IJobsiteSalesArea[];
  stdLot: MultipleStdLotSizeRes;
  plant?: Plant[];
  jobsiteFullSalesArea: FullSalesArea;
  realJobsiteAddress?: IAddress;
}

export const initialState: IJobsiteState = {
  required: false,
  disabled: false,
  visible: false,
  loaded: false,
  loading: false,
  jobsites: [],
  selected: null,
  address: null,
  stdLot: null,
  jobsiteSalesArea: [],
  plant: [],
  jobsiteFullSalesArea: null,
  realJobsiteAddress: null,
};

export function jobsiteReducer(state = initialState, action: JobsiteActions): IJobsiteState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      if (action.payload) {
        const jobsiteInitialState: ILocationConfigUnit = action.payload;
        return {
          ...state,
          disabled: jobsiteInitialState.disabled,
          required: jobsiteInitialState.required,
          visible: jobsiteInitialState.visible,
        } as IJobsiteState;
      }
      return {
        ...initialState,
      };
    }
    case LOAD:
    case LOAD_NO_SHIPPING_CONDITION:
    case LOAD_NO_DOCUMENTS:
    case LOAD_ADDRESS:
    case LOAD_SALES_AREA: {
      return {
        ...state,
        loading: true,
        loaded: false,
      } as IJobsiteState;
    }
    case LOAD_COMPLETE: {
      const shipmentLocations: IShipmentLocation[] = action.payload.shipmentLocations;
      return {
        ...state,
        loaded: true,
        loading: false,
        jobsites: shipmentLocations,
      } as IJobsiteState;
    }
    case JOBSITE_SET: {
      return {
        ...state,
        loaded: true,
        stdLot: null,
        selected: action.payload,
        realJobsiteAddress: null,
      } as IJobsiteState;
    }
    case LOAD_ADDRESS_SUCCESS: {
      let jobsiteAddress: IAddressResponse = action.payload;
      if (jobsiteAddress && jobsiteAddress.countryCode) {
        jobsiteAddress = {
          ...jobsiteAddress,
          countryCode: jobsiteAddress.countryCode.replace(/\s/g, ''),
        };
      }
      return {
        ...state,
        loading: false,
        address: jobsiteAddress,
        realJobsiteAddress: jobsiteAddress,
      } as IJobsiteState;
    }
    case PATCH_ADDRESS_COORDINATES: {
      const { latitude, longitude } = action.payload;
      return {
        ...state,
        loading: false,
        address: { ...state.address, geoPlace: { ...state.address.geoPlace, latitude, longitude } },
      } as IJobsiteState;
    }
    case LOAD_SALES_AREA_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        jobsiteSalesArea: action.payload,
      } as IJobsiteState;
    }
    case LOAD_FULL_SALES_AREA_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        jobsiteFullSalesArea: action.payload,
      } as IJobsiteState;
    }
    case LOAD_FULL_SALES_AREA_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: true,
        jobsiteFullSalesArea: null,
      } as IJobsiteState;
    }
    case LOAD_STD_LOT_SUCCESS: {
      return {
        ...state,
        stdLot: action.payload,
      };
    }
    case SET_JOBSITE_PLANT: {
      return {
        ...state,
        plant: action.payload,
      } as IJobsiteState;
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
    case JOBSITE_SET_AVAILABILITY: {
      return {
        ...state,
        disabled: action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
